import { getRecordKeys } from '@ipfabric/utils';
import { isPathLookupGraphMetadata } from 'components/Graph/GraphState';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { destroyPathLookupPathInspectorNode } from './destroyPathLookupPathInspectorNode';

export const destroyPathLookupPathInspector: GraphCommandFactory =
  (cmdContext, dispatch) => () => {
    const { pathlookup } = cmdContext.getState();
    if (
      isPathLookupGraphMetadata(cmdContext.getState().graphMetadata) &&
      Object.keys(pathlookup.pathInspector.selectedPackets).length > 0
    ) {
      for (const nodeSn of getRecordKeys(
        pathlookup.pathInspector.selectedPackets,
      )) {
        dispatch(destroyPathLookupPathInspectorNode, { nodeSn });
      }
    }
  };
